import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'rawImages': [],
  'loading': false,
};


export const warrantyAdminImages = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_TWC_WARRANTY_ADMIN_ATTACHMENTS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_TWC_WARRANTY_ADMIN_ATTACHMENTS]: (state, action) => {
      return {
        ...state,
        'loading': false,
        'rawImages': action.response.data,
      };
    },
    [ActionTypes.FETCHED_TWC_WARRANTY_ADMIN_ATTACHMENTS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'rawImages': [],
    }),
  })(state, action);
};
